import styled from 'styled-components'

export const Button = styled.button`
  background: none;
  padding: 0;
  border: none;

  &:focus {
    outline: none;
  }

  & + button {
    margin-left: 16px;
  }
`
